import "~group-by";
/* eslint-disable @typescript-eslint/ban-ts-comment */
import "v-contextmenu/dist/themes/default.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue-next/dist/bootstrap-vue-next.css";

import * as Sentry from "@sentry/vue";
import { createHead } from "@unhead/vue";
import { createBootstrap } from "bootstrap-vue-next";
import Cookies from "js-cookie";
import { SocketClient } from "socket-call-client";
// @ts-ignore
import contextmenu from "v-contextmenu";
import { createRouter, createWebHistory } from "vue-router";
import { routes } from "vue-router/auto-routes";

import App from "~/App.vue";
import i18n from "~/i18n";
import en from "~translations/messages.en.json";

const head = createHead();

const router = createRouter({
  history: createWebHistory(),
  routes,
});
router.beforeResolve(async (to) => {
  if (!to.meta.public && !Cookies.get("token") && to.path !== "/login") {
    router.push("/login");
    return false;
  }
});

const store = createPinia();

const app = createApp(App)
  .use(i18n("fr", localStorage.getItem("locale") || "fr", { en }).instance)
  .use(store)
  .use(createBootstrap())
  .use(contextmenu)
  .use(head)
  .use(router)
  .provide("dmSocket", new SocketClient(import.meta.env.VITE_DM_SOCKET_URL))
  .provide(
    "storySearchSocket",
    new SocketClient(import.meta.env.VITE_DM_STORY_SEARCH_SOCKET_URL),
  );

app.mount("#app");

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    integrations: [
      Sentry.vueIntegration({
        tracingOptions: {
          trackComponents: true,
          timeout: 1000,
          hooks: ["mount", "update", "unmount"],
        },
      }),
    ],
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    tracesSampleRate: 1.0,
  });
}
